import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {AppSettings} from '../../proyect.conf';
import {ProductoPasarela} from '../_models/producto-pasarela';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductoPasarelaService {
  private route: string = `${AppSettings.rutServiciosAPL}/api/productosPasarelas`;

  constructor(
    private httpClient: HttpClient,
    private authService: AutenticacionService
  ) {}

  getAll(): Observable<ProductoPasarela[]> {
    return this.httpClient.get<ProductoPasarela[]>(this.route);
  }

  getAllEnabled(): Observable<ProductoPasarela[]> {
    return this.httpClient.get<ProductoPasarela[]>(`${this.route}/enabled}`);
  }

  getById(id: string): Observable<ProductoPasarela[]> {
    return this.httpClient.get<ProductoPasarela[]>(`${this.route}/${id}`);
  }

  getByIdProducto(id: string): Observable<ProductoPasarela[]> {
    return this.httpClient.get<ProductoPasarela[]>(`${this.route}/producto/${id}`);
  }

  getByIdsProductos(ids: string[]): Observable<ProductoPasarela[]> {
    return this.httpClient.post<ProductoPasarela[]>(`${this.route}/producto/idProductoIn`, ids);
  }

  create(record: ProductoPasarela): Observable<ProductoPasarela> {
    record.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductoPasarela>(this.route, record);
  }

  update(record: ProductoPasarela): Observable<ProductoPasarela> {
    record.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado();
    return this.httpClient.put<ProductoPasarela>(this.route, record);
  }

  createBulk(records: ProductoPasarela[]): Observable<ProductoPasarela[]> {
    records.forEach((e: ProductoPasarela) => e.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoPasarela[]>(`${this.route}/bulk`, records);
  }

  updateBulk(records: ProductoPasarela[]): Observable<ProductoPasarela[]> {
    records.forEach((e: ProductoPasarela) => e.auditoriaUsuario = this.authService.obtenerIdUsuarioLogueado());
    return this.httpClient.put<ProductoPasarela[]>(`${this.route}/bulk`, records);
  }
}
